import { render } from "./photos.vue?vue&type=template&id=ed847668"
import script from "./photos.vue?vue&type=script&lang=js"
export * from "./photos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__